import { WProofreader } from '@webspellchecker/wproofreader-ckeditor5';
import {
  Bold,
  ClassicEditor,
  CloudServices,
  EasyImage,
  Emoji,
  Essentials,
  FontColor,
  Heading,
  ImageBlock,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  List,
  MediaEmbed,
  Mention,
  Paragraph,
  Strikethrough,
  TextTransformation,
  Underline,
} from 'ckeditor5';
import { ImagePreview } from '../plugins';

class RichTextEditorBase extends ClassicEditor {
  static override readonly builtinPlugins = [
    Indent,
    IndentBlock,
    Bold,
    Italic,
    Strikethrough,
    Underline,
    EasyImage,
    Essentials,
    FontColor,
    Heading,
    ImageBlock,
    ImageUpload,
    CloudServices,
    Link,
    List,
    Mention,
    Paragraph,
    MediaEmbed,
    TextTransformation,
    WProofreader,
    ImagePreview,
    Emoji,
  ];
}

export default RichTextEditorBase;
